import clsx from 'clsx';
import { Button, Checkbox } from '@/components/common';
import { useState } from 'react';
import { MERCHANT_TERMS } from '@/constants/common';
import styles from './Steps.module.css';

interface HostedQuestionProps {
  setStep: (step: number) => void;
  finish: () => void;
}

export const HostedQuestion = ({ setStep, finish }: HostedQuestionProps) => {
  const [isCheckboxShown, setIsCheckboxShown] = useState<boolean>(false);
  const [isTermsAccepted, setIsTermsAccepted] = useState<boolean>(false);

  function accept() {
    setStep(3);
  }

  const showCheckbox = () => setIsCheckboxShown(true);

  const toggleIsTermsAccepted = () => {
    if (!isTermsAccepted) accept();
    setIsTermsAccepted((prev) => !prev);
  };

  return (
    <div className={styles.form}>
      <h3 className={clsx(styles.title, styles.titleMultiline)}>
        Do you want to accept cryptocurrency as a payment option?
      </h3>
      <p className={styles.description}>
        If you want to have cryptocurrency as an option, you will need to fill in additional info for your hosted page,
        like logo, meta information and URL.
      </p>

      {!isCheckboxShown && (
        <Button fluid className={styles.buttonFullWidth} onPress={showCheckbox}>
          Yes, create hosted page
        </Button>
      )}

      {isCheckboxShown && (
        <Checkbox isSelected={isTermsAccepted} onChange={toggleIsTermsAccepted} className={styles.checkbox}>
          I accept the merchant{' '}
          <a className={styles.checkboxLink} target="_blank" rel="noreferrer noopener" href={MERCHANT_TERMS}>
            terms and conditions
          </a>
        </Checkbox>
      )}

      <Button fluid variants="secondaryGray" onPress={finish}>
        No, add this later
      </Button>
    </div>
  );
};
